import NoDataComponent from "./../../../Table/TableComponents/NoDataComponent";
import React from "react";
import { MdPeople } from "react-icons/md";

const foreign_worker_group_no_data = (props) => {
  return (
    <NoDataComponent
      {...props}
      icon={<MdPeople size={60} className="noDataIcon" />}
      headerinfo="No Foreign Worker Groups"
      subheaderinfo="Foreign Worker Groups will appear here"
    />
  );
};

export default foreign_worker_group_no_data;
